export function formatDateFromISOString(s): string {
  const date = new Date(s);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const dayNumber = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  const hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
  const minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
  const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds();
  const meridian = date.getHours() > 12 ? 'PM' : 'AM';
  return `${year}/${month}/${dayNumber} ${hour}:${minute}:${second} ${meridian}`;
}

export function formatSimpleDateTimeFromISOString(s): string {
  const date = new Date(s);
  const month = date.getMonth() + 1;
  const dayNumber = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  const hour = date.getHours() > 9 ? date.getHours() : '0' + date.getHours();
  const minute = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes();
  return `${month}/${dayNumber} ${hour}:${minute}`;
}

export function nowISOString(): string {
  const now = new Date();
  return now.toISOString();
}

export function nowSimpleDate(): string {
  const s = nowISOString();
  return getSimpleDateFromISOString(s);
}

export function simpleDateSevenDaysAgo(): string {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const dayNumber = date.getDate();
  const sevenDaysAgo = new Date(year, month, dayNumber - 7);
  const s = sevenDaysAgo.toISOString();
  return getSimpleDateFromISOString(s);
}

export function makeDateURLSafe(s): string {
  const regex = /\//g;
  return s.replace(regex, '-');
}

export function getArrayOfLastThirtyDays(): [] {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const dayNumber = date.getDate();
  const dateArray = [];
  let temp = '';
  let tempDay = 0;
  for (let i = 29; i >= 0; i--) {
    tempDay = dayNumber - i;
    temp = new Date(year, month, tempDay);
    dateArray.push(temp);
  }
  // Add extra days to beginning so that "30 days" always begins with a Sunday
  let j = 1;
  while (dateArray[0].getDay() !== 0) {
    tempDay = dayNumber - 29 - j;
    temp = new Date(year, month, tempDay);
    dateArray.unshift(temp);
    j++;
  }
  return dateArray;
}

export function getSimpleHoursMinutesFromISOString(s): string {
  const date = new Date(s);
  let hour = date.getHours();
  let minute = Math.round(date.getMinutes() / 10) * 10;
  if (minute === 60) {
    minute = 0;
    if (hour < 23) {
      hour += 1;
    } else {
      // This is a hack until we're able to deal with a reading that isn't the first being at midnight
      hour = 23;
      minute = 50;
    }
  }
  return `${hour}:${minute}`;
}

export function getSimpleMonthDayHoursMinutesFromISOString(s, intervalMinutes): string {
  const date = new Date(s);
  let month = date.getMonth() + 1;
  let day = date.getDate();
  let hour = date.getHours();
  let minute = Math.round(date.getMinutes() / intervalMinutes) * intervalMinutes;
  if (minute === 60) {
    minute = 0;
    if (hour < 23) {
      hour += 1;
    } else {
      hour = 0;
      day++;
      if (day === 32) {
        if (month === 12) {
          month = 1;
        } else {
          month++;
        }
        day = 1;
      }
    }
  }
  return `${month}/${day} ${hour}:${minute}`;
}

export function getSimpleDateFromISOString(s): string {
  const date = new Date(s);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : ('0' + date.getMonth() + 1).slice(-2);
  const dayNumber = date.getDate() > 9 ? date.getDate() : '0' + date.getDate();
  return `${year}/${month}/${dayNumber}`;
}

